
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/convert/history",
      function () {
        return require("private-next-pages/convert/history.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/convert/history"])
      });
    }
  